import React from 'react';
import Button from '../button/Button';
import Modal from '../modal/Modal';
import style from './UserInstructionsModal.module.scss';
import useLabels from '../../hooks/useLabels';
import parse from 'html-react-parser';
import Alert from '../alert/Alert';
import Loader from '../loader/Loader';
import useTerms from '../../hooks/useTerms';

type Props = {
    isModalOpen: boolean;
    closeModal: () => void;
};

const UserInstructionsModal: React.FC<Props> = ({ isModalOpen, closeModal }) => {
    const labels = useLabels();
    const { terms, isLoading, error } = useTerms({ active: isModalOpen });
    
    return (<>
        <Modal
            className={style.modal}
            size='large'
            isOpen={isModalOpen}
            headline={labels.userInstructions}
            body={<>
            <Loader isVisible={isLoading} />
            {terms && <div className={style.termsContent}>{parse(terms?.text?.trim())}</div>}
            {error && <Alert headline={error.message} type='error' />}
            </>}
            footer={<Button label={labels.disclaimerButton} onClick={closeModal} />}
            closeOnBackdropClick
            closeOnEscape
            onClose={closeModal}
        />
    </>
    );
};

export default UserInstructionsModal;